import { ContractModificationGround } from "../../../autogen/bff-api";

export const exceedsHalfOfOriginalValue = (
  original: number | null,
  before: number | null,
  after: number | null,
): boolean => original !== null && before !== null && after !== null && after - before > original / 2;

export const MODIFICATION_GROUNDS = [
  ContractModificationGround.AdditionalDeliveries,
  ContractModificationGround.UnforeseenCircumstances,
] as const;

export type ModificationRegime = "foa" | "utilities";

export const regimeOf = (form: string): ModificationRegime => (form === "39" ? "utilities" : "foa");
